import { useEffect, useState } from "react";
import { ArrowRight } from "lucide-react";
import { onAnchor } from "../../lib/scroll";

export const MobileBar = () => {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const fn = () => setShow(window.scrollY > window.innerHeight * 0.8);
    fn();
    window.addEventListener("scroll", fn, { passive: true });
    return () => window.removeEventListener("scroll", fn);
  }, []);
  return (
    <div
      className={`fixed inset-x-3 bottom-3 z-40 transition-[transform,opacity] duration-500 md:hidden ${show ? "translate-y-0 opacity-100" : "pointer-events-none translate-y-24 opacity-0"}`}
    >
      <a
        href="#buchung"
        onClick={onAnchor("buchung")}
        data-testid="mobile-book-bar"
        className="flex items-center justify-between rounded-full bg-navy px-6 py-4 text-sm font-bold text-white shadow-[0_20px_40px_-15px_rgba(10,27,51,0.6)] ring-1 ring-white/15"
      >
        Kursplatz sichern <ArrowRight className="h-4 w-4" />
      </a>
    </div>
  );
};
